import { defineMessages } from '@jutro/locale';

export default defineMessages({
    whatAreStateFees: {
        id: 'ml.gateway.MLPolicyBillingPremiumFeesComponent.What are state fees',
        defaultMessage: 'What are state fees?'
    },
    feesChargedByState: {
        id: 'ml.gateway.MLPolicyBillingPremiumFeesComponent.These are fees charged by the state that we collect on their behalf and remit back to the state',
        defaultMessage: 'These are fees charged by the state that we collect on their behalf and remit back to the state.'
    },
    whatIsIncludedUnderFees: {
        id: 'ml.gateway.MLPolicyBillingPremiumFeesComponent.What is included under fees',
        defaultMessage: 'What is included under fees?'
    },
    feesChargedByCompany: {
        id: 'ml.gateway.MLPolicyBillingPremiumFeesComponent.These are company initiated fees such as payment processing fees, late fee charges or nonsufficient fund (NSF) fees if applicable on the policy',
        defaultMessage: 'These are company initiated fees such as payment processing fees, late fee charges or nonsufficient fund (NSF) fees if applicable on the policy.'
    }
});